// extracted by mini-css-extract-plugin
module.exports = {"lessenTip":"lessenTip--iLUQB"};